const useIsMouseEvent = () => {
    return (e) => ['mousedown', 'mousemove', 'mouseup', 'mouseleave'].includes(e.type);
}

export default useIsMouseEvent;